export default __webpack_public_path__ + "static/media/map-placeholder.83dd8b92.png";